import React from "react";

const StyledComponentsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 48 48"
    >
      <defs>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJa"
          cx="8.624"
          cy="32.013"
          r="28.015"
          data-name="Безымянный градиент 562"
          gradientTransform="rotate(133.673 2.756 18.298) scale(1 .143)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffda4b"></stop>
          <stop offset="0.629" stopColor="#ffc800"></stop>
          <stop offset="0.749" stopColor="#ffc200"></stop>
          <stop offset="1" stopColor="#ff9f00"></stop>
        </radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJb"
          cx="12.445"
          cy="20.632"
          r="9.076"
          data-name="Безымянный градиент 584"
          gradientTransform="matrix(-1 .022 -.003 -.157 32.531 26.312)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.022" stopColor="#ff6177"></stop>
          <stop offset="1" stopColor="#ea001e"></stop>
        </radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJc"
          cx="14.362"
          cy="37.069"
          r="26.714"
          gradientTransform="matrix(-.726 .688 -.108 -.114 28.796 31.421)"
          xlinkHref="#hdQkWLsLJ_BdJ5s97njkJa"
        ></radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJd"
          cx="20.199"
          cy="17.01"
          r="9.076"
          gradientTransform="matrix(-1 .022 -.003 -.157 48.315 28.494)"
          xlinkHref="#hdQkWLsLJ_BdJ5s97njkJb"
        ></radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJe"
          cx="19.734"
          cy="42.172"
          r="22.68"
          gradientTransform="matrix(-.721 .693 -.122 -.127 39.113 33.861)"
          xlinkHref="#hdQkWLsLJ_BdJ5s97njkJa"
        ></radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJf"
          cx="27.938"
          cy="20.367"
          r="9.076"
          gradientTransform="matrix(-1 .022 -.003 -.157 59.163 36.698)"
          xlinkHref="#hdQkWLsLJ_BdJ5s97njkJb"
        ></radialGradient>
        <radialGradient
          id="hdQkWLsLJ_BdJ5s97njkJg"
          cx="31.304"
          cy="29.056"
          r="2.951"
          xlinkHref="#hdQkWLsLJ_BdJ5s97njkJb"
        ></radialGradient>
        <linearGradient
          id="hdQkWLsLJ_BdJ5s97njkJh"
          x1="31.081"
          x2="37.543"
          y1="15.866"
          y2="20.877"
          data-name="Безымянный градиент 579"
          gradientTransform="rotate(-36.254 36.737 15.236)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.277" stopColor="#535353"></stop>
          <stop offset="0.469" stopColor="#a5a5a5"></stop>
          <stop offset="0.676" stopColor="#5b5b5b"></stop>
        </linearGradient>
        <linearGradient
          id="hdQkWLsLJ_BdJ5s97njkJi"
          x1="36.598"
          x2="46.355"
          y1="7.361"
          y2="11.184"
          data-name="Безымянный градиент 589"
          gradientTransform="rotate(-21.35 41.752 9.38)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.138" stopColor="#f01d33"></stop>
          <stop offset="0.458" stopColor="#ff6177"></stop>
          <stop offset="0.908" stopColor="#ea001e"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#hdQkWLsLJ_BdJ5s97njkJa)"
        d="M19.94 23.94a.345.345 0 01-.01.12 8.585 8.585 0 01-.82 2.49 9.048 9.048 0 01-.89 1.41 7.586 7.586 0 01-.76.85L.58 45.69l-.34.34a2.644 2.644 0 01.34-.41V34.64l11.36-11.36a10.246 10.246 0 012.35-1.64 9.99 9.99 0 012.54-.91h.09a3.027 3.027 0 012.25.96 3.123 3.123 0 01.77 2.25z"
      ></path>
      <ellipse
        cx="17.141"
        cy="23.606"
        fill="url(#hdQkWLsLJ_BdJ5s97njkJb)"
        rx="5.736"
        ry="2.324"
        transform="rotate(-45 17.141 23.607)"
      ></ellipse>
      <path
        fill="url(#hdQkWLsLJ_BdJ5s97njkJc)"
        d="M27.98 26.86a.345.345 0 01-.01.12 8.514 8.514 0 01-.81 2.49 8.611 8.611 0 01-1.65 2.26l-1.69 1.69c-.01.02-.02.03-.04.03L9.76 47.47H.58v-1.78l-.34.34a2.644 2.644 0 01.34-.41c.02-.02.04-.05.06-.07l17.58-17.59 1.76-1.76a10.518 10.518 0 014.89-2.55h.09a3.027 3.027 0 012.25.96 3.123 3.123 0 01.77 2.25z"
      ></path>
      <ellipse
        cx="25.185"
        cy="26.528"
        fill="url(#hdQkWLsLJ_BdJ5s97njkJd)"
        rx="5.736"
        ry="2.324"
        transform="rotate(-45 25.184 26.528)"
      ></ellipse>
      <path
        fill="url(#hdQkWLsLJ_BdJ5s97njkJe)"
        d="M31.08 34.71a.412.412 0 01-.01.12 8.514 8.514 0 01-.81 2.49 8.786 8.786 0 01-1.65 2.26l-7.89 7.89H9.67l13.41-13.42c.2-.18.43-.39.7-.6.02 0 .03-.01.04-.03a11.88 11.88 0 011.61-1.02 10.309 10.309 0 012.54-.9h.09a3.027 3.027 0 012.25.96 3.111 3.111 0 01.77 2.25z"
      ></path>
      <ellipse
        cx="28.284"
        cy="34.374"
        fill="url(#hdQkWLsLJ_BdJ5s97njkJf)"
        rx="5.736"
        ry="2.324"
        transform="rotate(-45 28.284 34.374)"
      ></ellipse>
      <path
        fill="url(#hdQkWLsLJ_BdJ5s97njkJg)"
        d="M34.1 29.1a4.21 4.21 0 01-3.285 2.815 4.282 4.282 0 01-2.5-.363 5.74 5.74 0 002.1-1.879 17.864 17.864 0 011.2-2.219c.129-.157 1.306-1.566 2.043-1.28.664.26.79 1.805.442 2.926z"
      ></path>
      <path
        fill="url(#hdQkWLsLJ_BdJ5s97njkJh)"
        d="M35.434 10.93H37.467V27.457H35.434z"
        transform="rotate(21.35 36.45 19.196)"
      ></path>
      <rect
        width="8.447"
        height="14.035"
        x="37.526"
        y="2.362"
        fill="url(#hdQkWLsLJ_BdJ5s97njkJi)"
        rx="0.808"
        transform="rotate(21.35 41.75 9.38)"
      ></rect>
    </svg>
  );
};

export default StyledComponentsIcon;
